import { Stack, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { PrimaryOutlinedButton } from '../../../components/style/ButtonStyle';
import { FormLabelText, FormTitle } from '../../../components/style/TextStyle';
import { DownloadIcon } from '../../../layouts/dashboard/nav/IconButton';

import { CategoryTab, CategoryTabs } from '../../../components/style/TabStyle';
import useResponsive from '../../../hooks/useResponsive';
import { responsiveMargin } from '../../../utils/enum';
import { CustomTabPanel, a11yProps, categoryList } from './CategoryList';
import DepartmentCategory from './DepartmentCategory';
import SportingCategory from './SportingCategory';
import StatusCategory from './StatusCategory';
import TypeCategory from './TypeCategory';

export default function CategoryListPage() {
  const [value, setValue] = useState(0);

  const mdUp = useResponsive('up', 'md');
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <Stack mx={responsiveMargin} spacing={5} my={{ xs: 2, md: 10 }}>
      {mdUp ? (
        <a
          href="https://drive.google.com/file/d/1-5pOs82bBcVoMze_r23Y-n0VGQlEkErv/view?usp=drive_link"
          target="_blank"
          rel="noreferrer"
        >
          <PrimaryOutlinedButton
            startIcon={<DownloadIcon />}
            sx={{ width: 'fit-content' }}
          >
            종류 관리 가이드 다운로드
          </PrimaryOutlinedButton>
        </a>
      ) : (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <FormLabelText sx={{ fontWeight: 700 }}>종류관리</FormLabelText>
          <a
            href="https://drive.google.com/file/d/1-5pOs82bBcVoMze_r23Y-n0VGQlEkErv/view?usp=drive_link"
            target="_blank"
            rel="noreferrer"
          >
            <PrimaryOutlinedButton
              startIcon={<DownloadIcon />}
              sx={{ fontSize: '12px', maxWidth: '220px' }}
            >
              종류 관리 가이드 다운로드
            </PrimaryOutlinedButton>
          </a>
        </Stack>
      )}

      <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
        {mdUp ? (
          <Stack spacing={2} sx={{ minWidth: '360px' }}>
            <Stack sx={{ height: '44px' }} justifyContent="center">
              <FormTitle>시설 관리 목록</FormTitle>
            </Stack>

            <CategoryTabs
              orientation="vertical"
              value={value}
              onChange={handleChange}
            >
              {categoryList.map(list => (
                <CategoryTab
                  key={list.id}
                  icon={list?.icon}
                  iconPosition="start"
                  label={list?.tab}
                  {...a11yProps(list?.index)}
                />
              ))}
            </CategoryTabs>
          </Stack>
        ) : (
          <Tabs value={value} onChange={handleChange}>
            {categoryList.map(list => (
              <Tab
                key={list.id}
                label={list?.mobile}
                sx={{
                  flex: 1,
                  fontWeight: 600,
                  borderBottom: { xs: '2px solid #E6E0E9', md: 'none' },
                  p: '4px',
                }}
                {...a11yProps(list?.index)}
              />
            ))}
          </Tabs>
        )}

        <CustomTabPanel value={value} index={0}>
          <TypeCategory />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <SportingCategory />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <StatusCategory />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <DepartmentCategory />
        </CustomTabPanel>
      </Stack>
    </Stack>
  );
}
